export default [
  // user
  // { exact: true, path: '/', redirect: '/tabBar/index' },
  { path: '/forward',key:'forward',component: '../components/forward/index'},
  {

    path: '/',
    key:'/base',
    component: '@/pages/base/index',
    routes: [

      {
        path: '/favorites',
        title: 'My Favorites  - ModCart Living',
        key:'/favorites',
        component: '@/pages/favoritesList/index',
        header:true
      },
      {
        path: '/',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/start',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/start',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/get10',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/get10',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/home',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/home',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/shop',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/shop',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/freedelivery',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/freedelivery',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/homepage',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/homepage',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/essentials',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/essentials',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/shopessentials',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/shopessentials',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/nextdaydelivery',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/nextdaydelivery',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/atlanta',
        title: 'ModCart Living - Curated items to fit your vibe, your space, and your look.',
        key:'/atlanta',
        component: '@/pages/home/index',
        header:true
      },
      {
        path: '/cart',
        key:'/cart',
        title: 'Cart - ModCart Living',
        badgeKey: 'myCart',
        // wrappers: [
        //   // 配置路由的高阶组件封装
        //   '@/authority/index', //用于路由级别的权限校验
        // ],
        component: '@/pages/myCart/index',
        header:true
      },

      { path: '/deal', key:'/deal', title:'deal', component: '@/pages/themelist/index',header:true },
      { path: '/getcoupon', key:'/getcoupon', title:'New User', component: '@/pages/invite/couponOnly',header:false },
      { path: '/p', key:'/p',title: '', component: '@/pages/details/index',header:true},
      { path: '/preview', key:'/preview',title: '', component: '@/pages/details/preview',header:true},
      { path: '/newuser', key:'/newuser', title:'New User', component: '@/pages/invite/couponOnly',header:false },
      { path: '/loginresult', key:'/loginresult', title:'New User', component: '@/pages/loginResult/index',header:false },
      { path: '/claimfreebie', key:'/claimfreebie', title:'Free Gift', component: '@/pages/freegiftAddress/index',header:false },
      { path: '/getfreebie', key:'/getfreebie', title:'Free Gift', component: '@/pages/invite/freebieOnly',header:false },
      { path: '/login', key:'/login', title:'Sign in / Sign up', component: '@/pages/login/index',header:false },
      { path: '/resetpassword',key:'/resetpassword',title:'Reset Password', component: '@/pages/resetPassword/index',header:false},
      { path: '/newpassword**',key:'/newpassword',title:'Reset Password', component: '@/pages/resetPassword/NewPassword',header:false},
      { path: '/needhelp',key:'/needhelp',title:'Reset Password', component: '@/pages/resetPassword/NeedHelp',header:false},
      // { path: '/category', component: '@/pages/category/index',breadcrumb:'category'},
      // { path: '/nav/category/:name', component: '@/pages/categoryGoodList/index',breadcrumb:({ match }:any)=>{
      //   console.log(match)
      //   return match.params.name
      // } },
      { path: '/c/:name',key:'/c', title:'Shop By Category' ,component: '@/pages/categoryGoodListScrollX/index',breadcrumb:({ match }:any)=>{
        console.log(match)
        return match.params.name
      },header:true},
      // { path: '/everydayextras',key:'/everydayextras', title:'Shop By Category' ,component: '@/pages/everydayExtrasList/index',header:true},
      { path: '/addresses',key:'/addresses', title:'My addresses - ModCart Living',component: '@/pages/addressBook/index',header:true},
      { path: '/addressedit', key:'/addressedit', title:'My addresses - ModCart Living',component: '@/pages/addressEdit/index',header:true},
      { path: '/checkorder',key:'/checkorder' ,title:'Checkout - ModCart Living',component: '@/pages/checkOrder/index',header:true},
      { path: '/checkoutresult',key:'/checkoutresult' ,title:'Thanks Order - ModCart Living', component: '@/pages/checkOutResult/index',header:true},
      { path: '/payments', key:'/payments', title:'Payment Options - ModCart Living',component: '@/pages/authorizePaymentList/index',header:true},
      { path: '/orderthanks/:id',key:'/orderthanks',title:'checkOutResult', component: '@/pages/orderThanks/index',
      header:true
      // wrappers: [
      //   // 配置路由的高阶组件封装
      //   '@/authority/index', //用于路由级别的权限校验
      // ],
      },
      { path: '/paymentadd',key:'/paymentadd', title:'Payment Options - ModCart Living',component: '@/pages/authorizePaymentAdd/index',header:true},
      { path: '/orders',key:'/orders',title:'Placed Orders - ModCart Living', component: '@/pages/orderHistory/index',header:true},
      { path: '/orderdetail', key:'/orderdetail',title:'Order Details - ModCart Living',component: '@/pages/orderDetail/index',header:true},
      { path: '/account',key:'/account', title:'My Profile - ModCart Living',component: '@/pages/mine/index',header:true},
      { path: '/search', key:'/search',title:'',component: '@/pages/search/index',header:false},
      { path: '/s', key:'/s',title:'',component: '@/pages/searchResult/index',header:true},
      { path: '/editprofile',key:'/editprofile', title:'My Profile - ModCart Living',component: '@/pages/editUserProfile/index',header:false},
      { path: '/returnorreplace', key:'/returnorreplace',title:'Return | Replace - ModCart Living',component: '@/pages/returnOrReplace/index',header:true},
      { path: '/return', key:'/return', title:'Return - ModCart Living',component: '@/pages/return/index',header:true},
      { path: '/replace',key:'/replace', title:'Replace - ModCart Living',component: '@/pages/return/index',header:true},
      { path: '/buyagain',key:'/buyagain', title:'Buy Again - ModCart Living',component: '@/pages/buyAgain/index',header:false},
      { path: '/coupons',key:'/coupons', title:'My Coupons - ModCart Living',component: '@/pages/coupons/index',header:true},
      { path: '/refer',key:'/refer',title:'Refer a friend - ModCart Living', component: '@/pages/refer/index',header:true},

      { path: '/invite',key:'/invite',title:'Sign in / Sign up - ModCart Living', component: '@/pages/referSignUp/index',header:false},
      // { path: '/everyday-extras',key:'/everyday-extras', title:'everyday-extras - ModCart Living',component: '@/pages/productInfoList/index',header:true},
      
      { path: '/instagram',key:'/instagram', title:'Instagram - ModCart Living',component: '@/pages/instagram/index',header:true},
      { path: '/helpus',key:'/helpus', title:'Help Us - ModCart Living',component: '@/pages/helpus/index',header:true},
      { path: '/faq',key:'/faq', title:'Frequently Asked Questions - ModCart Living',component: '@/pages/helpus/faq/index',header:true},
      { path: '/contactus',key:'/contactus', title:'About Us/Contact Us - ModCart Living',component: '@/pages/helpus/aboutAndContactUs/index',header:true},
      { path: '/policies',key:'/policies', title:'Our Policies/Terms of Use - ModCart Living',component: '@/pages/helpus/policiesAndTerms/index',header:true},
      
      { path: '/page-404', key:'/page-404' ,title:'404 - ModCart Living',component: '@/pages/404/index',header:true },
      { path: '/*', redirect: '/page-404' },
      { path: '/**/*', redirect: '/page-404' },
    ]
  },

];


